import assets from './assets.reducer';
import canvas from './canvas.reducer';
import editor from './editor.reducer';
import elements from './elements.reducer';
import metadata from './metadata.reducer';
import navigation from './navigation.reducer';
import page from './page.reducer';
import permission from './permission.reducer';
import text from './text.reducer';
import user from './user.reducer';

export default {
  assets,
  canvas,
  editor,
  elements,
  metadata,
  navigation,
  page,
  permission,
  text,
  user
};
